import { fetchServiceContractPdf, type ServiceContractPdfTab } from '@/api/serviceContract'
import { SERVICE_CONTRACT_TABS } from '@/composables/useServiceContractForm'

export async function requestServiceContractPdfBlob(
  tab: ServiceContractPdfTab,
  form: Record<string, unknown>,
): Promise<{ blob: Blob; filename: string }> {
  const blob = await fetchServiceContractPdf({ tab, form, disposition: 'inline' })
  const label =
    tab === 'all'
      ? '전체'
      : SERVICE_CONTRACT_TABS.find((t) => t.id === tab)?.label || tab
  const org = String(form.orgName || '').trim() || '기관'
  const filename =
    tab === 'all'
      ? `함우리_서비스계약서_${org}.pdf`.replace(/\s+/g, '_')
      : `함우리_서비스계약서_${label}_${org}.pdf`.replace(/\s+/g, '_')
  return { blob, filename }
}

export function downloadPdfBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), 30_000)
}
